<template>
  <!-- new bar start-->
  <div
    id="sidebar"
    :class="{ 'nav-collapse': true }"
    v-if="hasSubMenu">
    <!-- sidebar menu start-->
    <div class="leftside-navigation sidebar">
      <el-menu>
        <el-menu-item
          class="iconfont"
          v-for="item in menu.child"
          :class="{'selected': item.current == 1}"
          :index="item.title"
          :key="item.id">
          <a
            :href="item.href"
            target="_blank">
            {{ getText(item.title) }}
          </a>
        </el-menu-item>
      </el-menu>
    </div>
    <!-- sidebar menu end-->
    {{ menu }}
  </div>
  <!-- new bar end-->
</template>
<style src="../../assets/css/fontFace.css"></style>
<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
    };
  },
  methods: {
    getText(text) {
      return this.isInterviewSite ? this.$t(text) : text;
    }
  },
  computed: {
    ...mapState([
      'menu',
    ]),
    hasSubMenu() {
      return this.menu.child && this.menu.child.length > 0;
    }
  },
};
</script>
<style src="../../assets/css/fontFace.css"></style>
<style >
  .sidebar{
    font-size: 16px;
    font-weight: bold;
    color: #000;
    overflow: auto;
    padding-bottom: 100px;
    height: 100%;
  }
  .sidebar .el-menu{
    background: #fff;
  }
  .sidebar .el-menu-item-group__title{
    height: 56px;
    line-height:56px;
    padding: 0;
    background: #55acee;
    font-size: 18px;
    color: #fff;
  }
  .sidebar .el-menu-item-group__title:before{
    display: inline-block;
    width: 16px;
    height: 16px;
    background: url("../../assets/images/leftico01.png");
    margin-right: 10px;
    margin-top: -3px;
    vertical-align: middle;
    content: '';
  }
  .sidebar .el-menu-item{
    position: relative;
    padding:0 !important;
    font-size: 16px;
    border-bottom: 1px solid #e2eaf0;
  }
  .sidebar .el-menu-item a{
    display: block;
    padding: 0 0 0 40px;
    color: #666;
  }
  .sidebar .selected a{
    color: #20a0ff;
  }
  .sidebar .selected::after{
    display: inline-block;
    position: absolute;
    top:0px;
    right: 20px;
    content: '\e60a';
    color: #20a0ff;
  }

</style>
